import { render } from "./EmployeeSubordinates.vue?vue&type=template&id=0142308c"
import script from "./EmployeeSubordinates.vue?vue&type=script&lang=js"
export * from "./EmployeeSubordinates.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__